import Api from '@/services/Api';
import {User} from '@/types';

export default {
    getUsers() {
        return Api().get<User[]>('users/list', {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    getRoles() {
        return Api().get<Array<{ id: string, name: string }>>('users/roles', {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    updateRole(user: string, role: string) {
        return Api().post('users/role', {user, role}, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    updatePassword(user: string, password: string) {
        return Api().post('users/password', {user, password}, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
    deleteUser(user: string) {
        return Api().delete('users/' + user, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'bearer ' + window.localStorage.getItem('token')
            }
        });
    },
};
